"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(bid, advertiserId) {
    var overrides = { advertisers: {} };
    // A normalized bid contains a cpm field, otherwise we're being given
    // a source bid
    // TODO: Does price exist anymore in association with bid?
    var ecpm = bid.cpm ? bid.cpm : bid.price ? bid.price / 100.0 : 0;
    overrides.advertisers[advertiserId] = { ecpm: ecpm };
    return overrides;
}
exports.default = default_1;
